const $ = jQuery;

const Slider = {
  init: function () {
    $(document).ready(function () {
      $(".section-hero").slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,

      });

      $(".testimonials-items").slick({
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,

        prevArrow:
          '<div class="arrow prev-arrow"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" transform="matrix(-1 0 0 1 48 0)" fill="white"/><path d="M24.3483 18.0788L18.7754 24.3483M18.7754 24.3483L24.3483 29.9212M18.7754 24.3483H29.2246" stroke="#513933" stroke-width="1.4"/></svg></div>',
        nextArrow:
          '<div class="arrow next-arrow"><svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" transform="translate(0.550781)" fill="white"/><path d="M24.2025 18.0788L29.7754 24.3483M29.7754 24.3483L24.2025 29.9212M29.7754 24.3483H19.3262" stroke="#513933" stroke-width="1.4"/></svg></div>',
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    });
  },
};

export default Slider;
